import { memo } from "react";
import Svg, { Path, Rect, type SvgProps } from "react-native-svg";

const SvgCheckbox = (props: SvgProps) => (
  <Svg fill="none" height={32} width={33} {...props}>
    <Rect fill={props.color} height={30} rx={3.75} width={30} x={1.345} y={1} />
    <Path
      clipRule="evenodd"
      d="M24.345 11c.439.44.439 1.152 0 1.591l-8.059 8.058a2 2 0 0 1-2.888-.062L9.276 16.09a1.125 1.125 0 1 1 1.658-1.52l3.593 3.919a.5.5 0 0 0 .722.015L22.754 11c.439-.44 1.151-.44 1.59 0"
      fill="#fff"
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCheckbox);
export default Memo;
